import React, { useContext, useRef, useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import Logo from '../../../../Assets/Images/logo.png'
import PlayStore from '../../../../Assets/Images/play-storeIcon.png'
import './Footer.css'
import String from '../../../../Assets/Localization/Local';
import { LangContext, CompanyData, userCookieContext, userSessionContext } from '../../../../App'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import { Link } from 'react-router-dom';
import cookie from 'react-cookies'

const MyMapComponent = withScriptjs(withGoogleMap((props) =>
  <GoogleMap
    defaultZoom={12}
    defaultCenter={props.defaultCenter}
  >
    {props.isMarkerShown && <Marker position={{ lat: props.marker.latitude, lng: props.marker.longitude }} />}
  </GoogleMap>
))

const Footer = () => {
  let HBUser_cookie = cookie.load("HBUser");
  let HBUser_sessionStorage = sessionStorage.getItem("HBUser");

  const { lang } = useContext(LangContext)
  const { userCookie, handleUserCookie } = useContext(userCookieContext)
  const { userSession, handleUserSession } = useContext(userSessionContext)
  const { data } = useContext(CompanyData)
  let contactRef = useRef(null);
  let tabLinkRef = useRef(null);
  let appeardlink = useRef(null);
  const [socialData, setSocialData] = useState({})


  console.log('data==> ', data);
  String.setLanguage(lang);

  let copy = '\u00A9';

  useEffect(() => {
    let temp = {}
    if (data && data.socialLinks) {
      for (let i = 0; i < data.socialLinks.length; i++) {
        temp[data.socialLinks[i].key] = data.socialLinks[i].value
      }
      console.log('tempppp-> ', temp, temp.FACEBOOK ? true : false)
      setSocialData(temp)
    }
  }, [data])

  useEffect(() => {


    if (HBUser_cookie === undefined && (JSON.stringify(HBUser_sessionStorage) === null || JSON.stringify(HBUser_sessionStorage) === "null")) {
      tabLinkRef.style.display = 'none';
      appeardlink.style.display = 'block';
    }
    else {
      // appeardlink.style.paddingTop = '20%!important';
      tabLinkRef.style.display = 'flex';
      appeardlink.style.display = 'none';
    }

  })

  useEffect(() => {
    if (lang === "en") {
      contactRef.style.textAlign = 'left';
      contactRef.style.paddingLeft = '20px !important'
    }
    else {
      contactRef.style.textAlign = 'right';
      contactRef.style.paddingRight = '20px !important'

    }

  }, [lang])


  return (
    <div className="Footer mt-5">
      <div className="Footer_firstPart">
        <div className="Footer_wave"></div>
        <div className="Footer_content">
          <Container fluid>
            <Row className="h-100 w-100" style={{ paddingBottom: '27px' }}>
              <Col xl="3" lg="4" md="6" sm="6" xs="12" className="h-100" className="LogoPart p-0 py-4">
                <div className="LogoPart-content">
                  <div className="ImgDiv">
                    <img src={Logo} className="LogoImg img-fluid" />
                  </div>
                  <Row className="ShareBtns m-0 p-0">
                    <Col lg="6" md="6" sm="12" xs="4" className="p-1" >
                      <a href={data && data.iosUrl} target="_blank" className="ShareLink ">
                        <span ><i className="fab fa-apple fa-2x mx-3"></i></span>
                        <span >Git It From <b className="word">Appstore</b></span>
                      </a>
                    </Col>
                    <Col lg="6" md="6" sm="12" xs="4" className="p-1 h-100" >
                      <a href={data && data.androidUrl} target="_blank" className="ShareLink ">
                        <span ><img src={PlayStore} style={{ paddingLeft: '10px' }} /></span>
                        <span style={{ display: 'flex', color: '#fff' }}>
                          <span style={{ marginLeft: '11px' }}>Git It From <b className="word">Playstore</b></span></span>
                      </a>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col xl="3" lg="4" md="6" sm="6" xs="12" className="h-100" className="LinksPart">
                <Row ref={el => (tabLinkRef = el)} className="ROW w-100">
                  <Col lg="6" md="6" sm="6" xs="6">
                    <ul className="p-0">
                      <li>
                        <Link to="/HealthBook-Web/Home">{String.home}</Link>
                      </li>
                      <li>
                        <Link to="/HealthBook-Web/about-us">{String.aboutUs}</Link>
                      </li>
                      <li>
                        <Link to="/HealthBook-Web/ViewFamily">{String.Family}</Link>
                      </li>
                      <li>
                        <Link to="/HealthBook-Web/ViewChildren">{String.childern}</Link>
                      </li>
                    </ul>
                  </Col>
                  <Col lg="6" md="6" sm="6" xs="6" style={{ textAlign: lang === 'ar' ? 'right' : 'left' }}>
                    <ul className="p-0">
                      <li style={{ height: '46px' }}></li>
                      <li><Link to="/HealthBook-Web/ViewAnimals">{String.animals}</Link></li>
                      <li><Link to="/HealthBook-Web/Privacy">{String.privacyPolicy}</Link></li>
                      <li><Link to="/HealthBook-Web/RulesandConditions">{String.termsAndConditions}</Link></li>
                    </ul>
                  </Col>
                </Row>
                <Row ref={el => (appeardlink = el)}>
                  <Col lg="12" style={{ textAlign: lang === 'ar' ? 'right' : 'left' }}>
                    <ul>
                      <li> <Link to="/HealthBook-Web/">{String.home}</Link></li>
                      <li><Link to="/HealthBook-Web/about-us">{String.aboutUs}</Link></li>
                      <li><Link to="/HealthBook-Web/Privacy">{String.privacyPolicy}</Link></li>
                      <li><Link to="/HealthBook-Web/RulesandConditions">{String.termsAndConditions}</Link></li>
                    </ul>
                  </Col>
                </Row>
              </Col>
              <Col xl="3" lg="4" md="6" sm="6" xs="12" className="h-100" ref={el => (contactRef = el)} className="ContactPart px-1" >
                <div className='ContactPart-content'>
                  <h5 className="d-flex align-items-baseline"><i class="fas fa-envelope SocialIcon mx-2"></i>{data && data.email}</h5>
                  <h5 className="d-flex align-items-baseline" style={{ cursor: "pointer" }}>
                    <a href={`tel:${data && data.phone}`} style={{ color: "white" }}>
                      <i class="fas fa-mobile-alt SocialIcon mx-2"></i>
                      {data && data.phone}
                    </a>
                  </h5>
                  <div className="SocialContacts">

                    <Row className="px-4 ">
                      {socialData["LINKEDIN"] &&
                        <Col xs="2" className="d-flex align-items-center justifiy-content-center">
                          <a href={socialData["LINKEDIN"]} target="_blank"><span ><i class="fab fa-linkedin-in"></i></span></a>
                        </Col>
                      }
                      {socialData["YOUTUBE"] &&
                        <Col xs="2" className="d-flex align-items-center justifiy-content-center">
                          <a href={socialData["YOUTUBE"]} target="_blank"><span ><i class="fab fa-youtube"></i></span></a>
                        </Col>
                      }
                      {socialData["INSTAGRAM"] &&
                        <Col xs="2" className="d-flex align-items-center justifiy-content-center">
                          <a href={socialData["INSTAGRAM"]} target="_blank"><span><i class="fab fa-instagram"></i></span></a>
                        </Col>
                      }

                      {socialData["WHATSAPP"] &&
                        <Col xs="2" className="d-flex align-items-center justifiy-content-center">
                          <a href={`tel:${socialData["WHATSAPP"]}`}>
                            <span>
                              <i class="fab fa-whatsapp"></i>
                            </span>
                          </a>
                        </Col>
                      }
                      {socialData["FACEBOOK"] &&
                        <Col xs="2" className="d-flex align-items-center justifiy-content-center">
                          <a href={socialData["FACEBOOK"]} target="_blank"><span ><i class="fab fa-facebook-f" ></i></span></a>
                        </Col>
                      }
                    </Row>

                  </div>
                </div>
              </Col>
              <Col xl="3" lg="12" md="6" sm="6" xs="12" className="h-100" style={{ paddingTop: '6%' }}>
                {<MyMapComponent
                  isMarkerShown
                  marker={{ latitude: data ? data.location.lat : 25.8103146, longitude: data ? data.location.long : -80.1751609 }}
                  defaultCenter={{ lat: data ? data.location.lat : 25.8103146, lng: data ? data.location.long : -80.1751609 }}
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCHOldbL841fdZfoOxt8csv5a5jxRAct3Y&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `200px` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                />}
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <div className="Footer_secondPart">
        <span> Copyright {copy} 2020 Health Book</span>
      </div>
    </div >
  );
}

export default Footer;
